module.exports = __webpack_public_path__ + "img/instadebit.05ea2db6.svg";